import API from '@/views/Fdc/Apis/'
import _ from 'lodash'

export default {
  name: 'ModelGrid',
  watch: {
  },
  beforeMount () {
    this.initColumns()
  },
  props: {
    selectedTreeNode: {
      type: [Array, Object],
      default: () => []
    }
  },
  methods: {
    /**
     * 인자로 받은 rows의 _sel 을 true
     *
     * @param {*} [rows=[{}]]
     */
    selectRows (rows = [{}]) {
      rows.forEach(item => {
        if (item._status && (item._status.added || item._status.modified)) {
          item._status.checked = true
        }
      })
      return rows
    },
    /**
     * Detection Type별 컬럼 설정
     */
    initColumns () {
      this.columns = [
        { headerName: this.$t('fdc.COMMON.COLUMN.FAB'), field: 'fab', width: 100, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.EQP_ID'), field: 'eqpId', width: 100, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.MODULE_ID'), field: 'moduleId', width: 100, hide: true },
        { headerName: this.$t('fdc.SPC.COLUMN.LOT_STEP_YN'), field: 'lotStepYn', width: 100, hide: true },
        { headerName: this.$t('fdc.COMMON.COLUMN.CREATE_DATE'), field: 'createDt', width: 100, hide: true },
        { headerName: this.$t('fdc.SPC.COLUMN.CREATE_USER'), field: 'createUser', width: 100, hide: true }
      ]
      this.columns.push({ headerName: this.$t('fdc.SPC.COLUMN.PARAM_ALIAS'), field: 'paramAlias', width: 100, checkboxSelection: true, headerCheckboxSelection: true })
      this.columns.push({ headerName: this.$t('fdc.SPC.COLUMN.SMRY_TYPE'), field: 'smryType', width: 120 })
      this.columns.push({ headerName: this.$t('fdc.COMMON.COLUMN.RECIPE'), field: 'recipeId', width: 80 })
      this.columns.push({ headerName: this.$t('fdc.COMMON.COLUMN.STEP'), field: 'stepId', width: 65 })
      this.columns.push({ headerName: this.$t('fdc.SPC.COLUMN.USE_YN'), field: 'useYn', width: 90, type: 'checkboxColumn' }) // dataMap: ['Y', 'N'] })
      this.columns.push({ headerName: this.$t('fdc.COMMON.COLUMN.USL'), field: 'uslVal', width: 60, type: 'numericColumn' })
      this.columns.push({ headerName: this.$t('fdc.COMMON.COLUMN.UCL'), field: 'uclVal', width: 60, type: 'numericColumn' })
      this.columns.push({ headerName: this.$t('fdc.SPC.COLUMN.CL_VAL'), field: 'clVal', width: 60, type: 'numericColumn' })
      this.columns.push({ headerName: this.$t('fdc.COMMON.COLUMN.LCL'), field: 'lclVal', width: 60, type: 'numericColumn' })
      this.columns.push({ headerName: this.$t('fdc.COMMON.COLUMN.LSL'), field: 'lslVal', width: 60, type: 'numericColumn' })
      this.columns.push({ headerName: this.$t('fdc.SPC.COLUMN.SIGMA_ESTIMATE'), field: 'sigmaEstimate', width: 120, type: 'numericColumn' })
      this.columns.push({ headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_USER'), field: 'modifyUser', width: 100 })
      this.columns.push({ headerName: this.$t('fdc.COMMON.COLUMN.MODIFY_TIME'), field: 'modifyDt', width: 150, type: 'dateTimeColumn' })
    },
    /**
     * Model 리스트 조회
     */
    async searchModelList (nodeDetail) {
      let payload = {
        fab: nodeDetail.fab,
        eqpId: nodeDetail.eqpId,
        moduleId: nodeDetail.moduleId,
        lotStepYn: this.lotStepYn
      }

      // Summary Data & Model List API 호출
      let data = await API.Model.getSpcModels(payload)
      this.rowData = data
      this.$refs.modelGrd.gridApi.paginationSetPageSize(data.length)
    },
    /**
     * 컬럼 필수 저장 값 check
     *
     * 2021.05.13
     * 선택된 SPC Rule이 한 개도 존재하지 않을 경우에도 저장 가능하나,
     * 저장하지 못하도록 Validation 기능 추후 추가 개발 필요
     *
     */
    saveDataValidCheck () {
      const allRows = this.modelGrd.collectionView.items
      const checkedRows = allRows.filter(d => d._status.checked)
      const that = this
      return checkedRows.some(row => {
        const checkRequired = Object.keys(row).some(function (itemKey) {
          const column = that.modelGrd.columns.getColumn(itemKey)
          const colValue = row[itemKey]
          if (column !== null && column.isRequired) {
            switch (column.binding) {
              case 'fab':
              case 'eqpId':
              case 'moduleId':
                if (that.isEmpty(row[itemKey])) {
                  that.$dialog.alert(that.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Equipment']))
                  return true
                }
                break
              case 'createDt':
              case 'createUser':
                break
              default:
                if (that.isEmpty(colValue)) {
                  that.$dialog.alert(that.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_ENTERED', [column.header]))
                  return true
                }
                break
            }
          }
        })
        // 필수값
        if (checkRequired) { return true }
      })
    },
    /**
     * Model 데이터 저장
     *
     * 2021.05.13
     * Data 저장 후 grid refresh 하면 인덱스가 0으로 리셋되는 현상 있음
     *
     */
    async saveData () {
      const that = this

      let saveRows = []
      const checkedRows = this.$refs.modelGrd.getCheckedRows()
      const addedRows = this.$refs.modelGrd.getAddedRows()
      const updatedRows = this.$refs.modelGrd.getUpdatedRows()

      // 선택된 데이터가 없습니다.
      if (checkedRows < 1) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_NO_DATA_SELECTED'))
        return
      }

      checkedRows.some(row => {
        const rowStatus = row.briqueGridCud
        // 변경되어 선택된 저장 대상
        if (rowStatus === 'C' || rowStatus === 'U') {
          // const item = _.clone(row.dataItem)
          // delete item['_status']

          // // 로그인 기능이 없어 사용자 정보 없으므로 modifyUser 하드코딩
          // item['modifyUser'] = 'brique'

          row['useYn'] = row['useYn'] ? 'Y' : 'N'
          saveRows.push(row)
        }
      })

      // 변경된 데이터가 없습니다.
      if (saveRows < 1) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_NO_DATA_CHANGED'))
        return
      }

      let confirmMessage = ''
      const successMessage = this.$t('fdc.COMMON.MESSAGE.SUCCEED_SAVE')
      const failMessage = this.$t('fdc.COMMON.MESSAGE.FAILED_SAVE')
      if (!_.isEqual(saveRows.length, (addedRows.length + updatedRows.length))) {
        confirmMessage = this.$t('fdc.COMMON.MESSAGE.CONFIRM_UNCHECKED_CHANGED_DATA')
      }
      confirmMessage += this.$t('fdc.COMMON.MESSAGE.CONFIRM_SAVE')

      // if (this.saveDataValidCheck()) {
      //   return
      // }

      let payload = {
        dataList: saveRows
      }

      this.$dialog.confirm({
        message: confirmMessage,
        confirmText: this.$t('fdc.COMMON.BUTTON.CONFIRM'),
        cancelText: this.$t('fdc.COMMON.BUTTON.CANCEL'),
        onConfirm: async function () {
          const responseData = await API.Model.saveSpcModels(payload)
          if (responseData != null && responseData.status === 200) {
            that.$dialog.alert(successMessage)
            that.refreshModel()
          } else {
            that.$dialog.alert(failMessage)
          }
        }
      })
    },
    /**
     * tree에서 선택된 값을 search버튼일때 refresh일때?분리 모델 리스트 조회
     */
    searchModel (lotStepYn) {
      this.lotStepYn = lotStepYn
      let node = this.selectedTreeNode
      if (node.length === 0) {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Equipment']))
        return
      }
      if (node.detail.eqpModel === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['EQP Model']))
        return
      }
      if (node.detail.eqpId === '' || node.detail.moduleId === '') {
        this.$dialog.alert(this.$t('fdc.COMMON.MESSAGE.INFORM_ITEM_NOT_SELECTED', ['Module']))
        return
      }
      this.searchTreeNode = node
      this.searchModelList(node.detail)
    },
    /**
     * Model 새로고침 버튼 클릭
     */
    refreshModel () {
      if (this.searchTreeNode && this.searchTreeNode.length !== 0) {
        let selectEqpVo = this.searchTreeNode.detail
        this.searchModelList(selectEqpVo)
      }
    },
    /**
     * header check된 값이 있을때만 저장, 삭제 버튼 활성화
     */
    hasCheckedRows () {
      if (!this.$refs.modelGrd) {
        return 0
      }
      return this.$refs.modelGrd.checkedRowCount > 0
    },
    /**
     * tree node를 search하면 추가 버튼 활성화
     */
    isSearchNode () {
      if (!this.searchTreeNode.detail) {
        return false
      } else {
        let selectEqpVo = this.searchTreeNode.detail
        if (!this.isEmpty(selectEqpVo.fab) &&
          !this.isEmpty(selectEqpVo.eqpId) &&
          !this.isEmpty(selectEqpVo.moduleId)) {
          return true
        }
        return false
      }
    },
    // /**
    //  * Row Selected
    //  * @param {*} grid
    //  * @param {*} event
    //  */
    // selectedRow (grid, e) {
    //   var currentRow = e.panel.rows[e.row]

    //   if (currentRow) {
    //     if (!currentRow.dataItem._status.added) {
    //       this.$emit('model-row-selected', currentRow.dataItem)
    //     } else {
    //       this.$emit('model-row-selected', null)
    //     }
    //   }
    // },
    /**
     * null 값 check
     */
    isEmpty (value) {
      if (value === '' || value == null || value === undefined || (value != null && typeof value === 'object' && !Object.keys(value).length)) {
        return true
      } else {
        return false
      }
    },
    /**
     * BRIQUE grid selection change event
     * @param {*} rows selection rows
     */
    gridSelectionChanged (rows) {
      if (rows.length === 1) {
        var currentRow = rows[0]
        this.$emit('model-row-selected', currentRow)
      } else {
        // reset data
        this.$emit('model-row-selected', null)
      }
    },
    /**
     * BRIQUE Grid cell editing start method
     * @param {*} params 현재 row 연관 data
     */
    async onCellEditingStarted (params) {
      this.getStepListData(params.data)
      params.data.stepList = this.stepDataMap
      let stepList = []
      this.stepDataMap.forEach(item => {
        if (!stepList.includes(item.stepId)) {
          stepList.push(item.stepId)
        }
      })
      this.columns.map(c => {
        if (c.field === 'stepId') {
          c.cellEditor = 'agSelectCellEditor'
          c.cellEditorParams = {
            values: stepList
          }
        }
        return c
      })
      this.$refs.modelGrd.gridApi.setColumnDefs(this.columns)
    },
    /**
     * BRIQUE Grid External Filter 적용 여부 check
     * @returns {Boolean} check result
     */
    isExternalFilterPresent () {
      return !this.isEmpty(this.filterParam) || !this.isEmpty(this.filterRecipe) || !this.isEmpty(this.filterStep)
    },
    /**
     * BRIQUE Grid filter function
     * @param {*} node row data
     * @returns {Boolean} filter result
     */
    doesExternalFilterPass (node) {
      if ((this.filterParam === null || this.filterParam === '' || node.data.paramName.indexOf(this.filterParam) > -1) &&
        (this.filterRecipe === null || this.filterRecipe === '' || node.data.recipeId.indexOf(this.filterRecipe) > -1) &&
        (this.filterStep === null || this.filterStep === '' || node.data.stepId.indexOf(this.filterStep) > -1)) {
        return true
      } else {
        return false
      }
    },
    setLastestSelectedData (lastestSelectedData) {
      this.lastestSelectedData = lastestSelectedData
    },
    onRowDataChanged () {
      if (this.lastestSelectedData) {
        let tempData = this.lastestSelectedData
        const model = this.$refs.modelGrd.gridApi.getModel()
        const rowCount = model.getRowCount()
        for (let i = 0; i < rowCount; i++) {
          const node = model.getRow(i)
          if (node) {
            let { paramName, recipeId, smryType, lclVal, lslVal, uslVal } = node.data
            if (
              paramName === tempData.paramName &&
              recipeId === tempData.recipeId &&
              smryType === tempData.smryType &&
              lclVal === tempData.lclVal &&
              lslVal === tempData.lslVal &&
              uslVal === tempData.uslVal
            ) {
              node.setSelected(true)
              this.$refs.modelGrd.gridApi.ensureIndexVisible(node.rowIndex, 'middle')
              this.lastestSelectedData = null
              break
            }
          }
        }
      }
    }
  },
  data () {
    return {
      lastestSelectedData: null,
      columns: [],
      defaultColDef: {
        // minWidth: 100,
        filter: true,
        sortable: true,
        resizable: true
      }, // BRIQUE Grid column default setting
      rowData: [],
      searchTreeNode: [],
      lotStepYn: 'N'
    }
  }
}
